// extracted by mini-css-extract-plugin
export default {"section":"Projects_section__B+3KD","title":"Projects_title__1OBmj","container":"Projects_container__Z+PJ+","slideFromLeft":"Projects_slideFromLeft__TQkCK"};